module.exports = __webpack_public_path__ + "static/quran.a5063dbb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/logos/quran.svg
// module id = 875
// module chunks = 213534597649335